import React from 'react';
import './App.css';
import { Paper, Typography } from "@material-ui/core"
import Soundboard from "./Soundboard";

const App: React.FC = () => {

  return (
    <div className="Knalli ja Sateenvarjo Soundboard">
      <Paper elevation={1}
        style={{
          height: "100%"
        }}
      >
        <Paper elevation={2}
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around"
          }}
        >
          <Paper
            style={{
              display: "flex",
              flexGrow: 1
            }}
          >

          </Paper>
          <Paper
            style={{
              display: "flex",
              flexGrow: 666
            }}
          >
            <Typography
              variant="h2"
              style={{
                height: "100%",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",

              }}>
              Knalli & Sateenvarjo Soundboard
          </Typography>
          </Paper>
          <Paper
            style={{
              display: "flex",
              flexGrow: 1
            }}
          >

          </Paper>
        </Paper>
        <Soundboard />
        <Paper style={{ height: "2rem" }} />
        <Paper elevation={2}
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <div
            style={{
              width: "80%"
            }}
          >
            <Typography variant="h6">
              Mikä?
          </Typography>
            <Typography variant="body1">
              Knalli & Sateenvarjo Soundboard
          </Typography>
          </div>
        </Paper>
      </Paper>
    </div>
  );
}

export default App;
